export const SET_LANGAUGE = 'SET_LANGUAGE'

export const setLanguage = (language: any) => {
    localStorage.setItem("language", language)
    return { type: SET_LANGAUGE,  content:  language  }
}